<template>
    <span class="label"
          data-component="MellonWebECRIntentResultLabel"
          :class="color">
        {{ text }}
    </span>
</template>

<script>
import MellonWebECRIntentResult from '@/lib/PaymentMethods/MellonWebECR/Enums/MellonWebECRIntentResult';

export default {
    props: {
        /**
         * @type {MellonWebECRTransactionIntent}
         */
        intent: {
            type: Object,
            required: true,
        },
    },

    computed: {
        color() {
            if (this.intent?.Result) {
                if (this.intent.Result === MellonWebECRIntentResult.APPROVED) {
                    return 'label-success';
                }

                if (this.intent.Result === MellonWebECRIntentResult.UNKNOWN) {
                    return 'label-warning';
                }

                return 'label-danger';
            }

            return '';
        },

        text() {
            if (this.intent) {
                return Object.entries(MellonWebECRIntentResult).find((entry) => {
                    return entry[1] === this.intent.Result;
                })[0];
            }

            return '';
        },
    },
};
</script>
